/**
 * WordPress dependencies
 */
import type {
	dispatch as Dispatch,
	select as Select,
} from '@safe-wordpress/data';

/* eslint-disable */
const parent = window.parent as any;
const dispatch = parent.wp.data.dispatch as typeof Dispatch;
const select = parent.wp.data.select as typeof Select;
/* eslint-enable */

// NOTE. No @nab packages in front.
import type { store as dataStore } from '@nab/data';
const NAB_DATA = 'nab/data' as unknown as typeof dataStore;

export function initCssSelectorFinder(): void {
	const editor = select( NAB_DATA ).getPageAttribute(
		'css-editor/cssEditorState'
	);

	if ( ! editor ) {
		return;
	}

	const finder = select( NAB_DATA ).getPageAttribute(
		'css-selector/cssSelectorFinderState'
	);
	void dispatch( NAB_DATA ).setPageAttribute(
		'css-selector/cssSelectorFinderState',
		{
			alternative: 0,
			mode: 'css',
			value: '',
			interactionMode: ( () => {
				if ( 'navigation' === finder?.interactionMode ) {
					return 'navigation';
				}
				if ( 'content-editor' === editor.mode ) {
					return 'editable-content-inspector';
				}
				return 'flexible-inspector' === finder?.interactionMode
					? 'flexible-inspector'
					: 'single-inspector';
			} )(),
			breadcrumbs: [],
			autoHideOnInactivity: true,
		}
	);
}
